import React, {Component} from 'react';
import Typist from 'react-typist';
import Particles from "react-particles-js";
import ReactGA from 'react-ga';
import {script_set} from '../assets/story_set'
import buzz from 'buzz';
import {calResult} from "../config";

class Script extends Component {
    state = {
        cur_script: "",
        cur_scene: 1,
        cur_index: 0,
        script_load: false,
        next_scene_load: false,
        load: false,
        scale_style: "",
        hour: this.getTime('hour'),
        minutes: this.getTime('minutes'),
        sum_point: 0,
        is_sound: false,
    }
    bgm;
    effect;
    jungle_sound = new buzz.sound("https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/jungle_sound-min.mp3");
    chop_sound = new buzz.sound("https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/chop-min.mp3");

    bgm_arr = [
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/scene-4-5-min.mp3",
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/scene-6-min.mp3",
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/daynight-min.mp3",
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/last-min.mp3",
    ]
    effect_arr = [
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/warter_fall-min.mp3",
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/cave-min.mp3",
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/river-min.mp3",
        "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/cave-min.mp3"
    ]

    setBgm(index) {
        this.bgm = new buzz.sound(this.bgm_arr[index])
    }

    setEffect(index) {
        this.effect = new buzz.sound(this.effect_arr[index])
    }

    componentDidMount() {
        if (this.props.history.action === 'POP') {
            this.props.history.push('/')
        } else {
            this.soundToggle(0);
            this.setPageView(1);
            this.imagePreload(0);
            this.timeout = setTimeout(() => {
                this.setState({cur_script: script_set[0], load: true});
            }, 3000);
            this.interval = setInterval(() => {
                let hour = this.getTime('hour')
                let minutes = this.getTime('minutes')
                this.setState({hour: hour, minutes: minutes})
            }, 6000)
        }
    }

    componentWillUnmount() {
        this.jungle_sound.stop();
        if (this.bgm) {
            this.bgm.stop();
        }
        if (this.effect) {
            this.effect.stop();
        }
        clearTimeout(this.interval);
    }

    getTime(time_type) {
        let date = new Date()
        if (time_type === 'hour') {
            date = date.getHours() % 12 || 12;
        } else {
            date = date.getMinutes();
        }
        if (date < 10) {
            date = '0' + date
        }
        return date
    }

    async setLoad() {
        this.setState({script_load: true, next_scene_load: true});
    }

    imagePreload(scene) {
        let images = [];
        let img_list = [];
        let scene_1 = [
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Insects.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Leaf.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Owl.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Panther.png',
        ];
        let scene_2 = [
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Jacket-min.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Light-min.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Lighter-min.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Porn-min.png',
            'https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-SwissKnife-min.png',
        ];
        let scene_3 = [
            // "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Animated.png",
        ]
        let scene_4 = [
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-01-bg-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-Front-Left-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-Front-Right-min.png",

        ]
        let scene_5 = [
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-BG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-FG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Ancients-BG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Ancients-FG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Lake-BG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Lake-FG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Cave-BG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Cave-FG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-Wave-0.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-Wave-1.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-Wave-2.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-bird.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-Bat.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-Fish.png",
        ]
        let scene_6 = [
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_5/003-00-BG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_5/003-00-Cloud-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_6/003-01-BG-min.png",
        ]
        let scene_7 = [
            // "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Orang-Animated.png",
        ]
        let scene_8 = [
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-00-BG-min.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Animated-Note.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Animated-Phone.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Animated-Poit.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Stable-Note.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Stable-Phone.png",
            "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Stable-Poit.png",
        ]

        img_list = [
            scene_1,
            [],
            scene_2,
            scene_3,
            scene_4,
            scene_5,
            [],
            scene_6,
            scene_7,
            scene_8,
            [],
        ]

        if (img_list[scene]) {
            for (let i = 0; i < img_list[scene].length; i++) {
                images[i] = new Image();
                images[i].src = img_list[scene][i];
            }
        }
    }

    async nextScript(e, choice_index) {
        let cur_script = this.state.cur_script;
        let sum_point = this.state.sum_point;

        if (cur_script.is_last) {
            if(this.bgm) {
                this.bgm.stop();
            }
            this.props.history.push("/result/" + calResult(sum_point));
        } else {
            let index = this.state.cur_index;
            let script_load = false;
            let next_scene_load = false;
            let choice_event_chk = false;
            let choice_set = [{
                hidden: true,
                choice_event: ""
            }];
            let img_style, position, img_animation;
            if (this.state.is_sound) {
                this.chop_sound.play();
                if (cur_script.scene === 5) {
                    this.jungle_sound.fadeIn(3000).play();
                }
                if (cur_script.sound_scene) {
                    if (cur_script.sound_scene === 1) {
                        this.jungle_sound.fadeOut(3000).pause();
                        this.setBgm(0)
                        this.bgm.loop().setVolume(0).fadeTo(60, 5000).loop().play();
                    } else if (cur_script.sound_scene === 2) {
                        this.bgm.fadeOut(3000).stop();
                        this.setBgm(1)
                        this.bgm.loop().setVolume(0).fadeTo(60, 5000).loop().play();
                    } else if (cur_script.sound_scene === 3) {
                        this.setEffect(choice_index);
                        this.effect.fadeIn(5000).loop().play();
                    } else if (cur_script.sound_scene === 4) {
                        this.effect.stop();
                        this.effect = null;
                        this.jungle_sound.fadeOut(3000).pause();
                        this.bgm.fadeOut(3000).pause();
                        this.setBgm(2)
                        this.bgm.loop().setVolume(0).fadeTo(60, 5000).play();
                    } else if (cur_script.sound_scene === 5) {
                        this.bgm.fadeOut(3000).pause();
                        this.setBgm(3)
                        this.bgm.loop().setVolume(0).fadeTo(60, 5000).play();
                    }
                }
            }
            if (cur_script.choice_set[choice_index].choice_event === 'zoom') {
                let cur_dom = e.target.getBoundingClientRect();
                let window_rect = window.document.body.getBoundingClientRect();
                let cur_x = window_rect.width / 2 - (cur_dom.x + (cur_dom.width / 2));
                let cur_y = window_rect.height / 2 - (cur_dom.y + (cur_dom.height / 2));
                if (cur_script.choice_set[choice_index].choice_event_option.top) {
                    cur_y = cur_y + cur_script.choice_set[choice_index].choice_event_option.top;
                }
                await this.setState({
                    scale_style: {
                        transform: "scale(3) translate(" + cur_x + "px," + cur_y + "px)",
                        transition: "transform 300ms ease-out 50ms"
                    }
                })
                img_style = cur_script.choice_set[choice_index].img_style;
                position = cur_script.choice_set[choice_index].position;
                choice_event_chk = true;
            } else if (cur_script.choice_set[choice_index].choice_event === 'zoom_object') {
                img_style = cur_script.choice_set[choice_index].choice_event_option.img_style;
                position = cur_script.choice_set[choice_index].choice_event_option.position;
                img_animation = cur_script.choice_set[choice_index].choice_event_option.img_animation;
                choice_event_chk = true;
            } else {
                await this.setState({
                    scale_style: ""
                })
            }
            if (cur_script.choice_set[choice_index].point) {
                sum_point += cur_script.choice_set[choice_index].point;
                await this.setState({sum_point: sum_point})
            }
            if (choice_event_chk) {
                let img_url = cur_script.choice_set[choice_index].img_url;
                if (cur_script.choice_set[choice_index].next_msg.img_url) {
                    img_url = cur_script.choice_set[choice_index].next_msg.img_url;
                }
                choice_set = [
                    {
                        disabled: true,
                        img_url: img_url,
                        position: position,
                        img_style: img_style,
                        img_animation: img_animation,
                    }
                ]
            }
            if (cur_script.img_load) {
                await this.imagePreload(cur_script.scene);
            }
            if (cur_script.choice_set[choice_index].next_msg) {
                ReactGA.event({
                    category: "Story-1 [쫄보테스트]",
                    action: "Choice (SCENE-" + cur_script.script_scene + " [" + cur_script.title + "])",
                    label: cur_script.choice_set[choice_index].title
                });
                script_load = true;
                cur_script = {
                    scene: cur_script.scene,
                    sound_scene: cur_script.choice_set[choice_index].sound_scene,
                    background: cur_script.choice_set[choice_index].next_msg.background,
                    title: cur_script.choice_set[choice_index].next_msg.title,
                    msg: cur_script.choice_set[choice_index].next_msg.msg,
                    is_next_scene: true,
                    choice_set: choice_set
                }
            } else {
                index = this.state.cur_index + 1;
                cur_script = script_set[index];
            }
            await this.resetCurscript();
            if(this.state.cur_scene !== cur_script.scene) {
                this.setPageView(cur_script.scene);
            }
            await this.setState({
                cur_script: cur_script,
                cur_scene: cur_script.scene,
                cur_index: index,
                script_load: script_load,
                next_scene_load: next_scene_load
            });
        }
    }

    async resetCurscript() {
        await this.setState({cur_script: ""})
    }

    async soundToggle() {
        let scene = this.state.cur_scene;
        this.setState({is_sound: !this.state.is_sound}, () => {
            if (this.bgm) {
                this.state.is_sound ? this.bgm.play().loop().setVolume(0).fadeTo(60, 3000) : this.bgm.fadeOut(3000).pause();
            }
            if (this.effect) {
                this.state.is_sound ? this.effect.play().loop().fadeIn(5000) : this.effect.fadeOut(3000).pause();
            }
            if (scene >= 0 && scene <= 2) {
                this.state.is_sound ? this.jungle_sound.play().loop().setVolume(0).fadeTo(60, 5000) : this.jungle_sound.fadeOut(3000).pause();
            } else if (scene >= 5 && scene <= 7) {
                this.state.is_sound ? this.jungle_sound.play().loop().setVolume(0).fadeTo(60, 5000) : this.jungle_sound.fadeOut(3000).pause();
            }
        })
    }

    setPageView(scene){
        ReactGA.pageview('/jungle/scene/'+scene);
    }

    render() {
        const {cur_script, script_load, load, scale_style, next_scene_load, cur_scene, hour, minutes, is_sound} = this.state;
        let load_page, trans_style, back_ground, choice_set, next_scene_btn;
        if (scale_style) {
            trans_style = scale_style;
        }
        if (!load) {
            load_page = <div className="load_page dissolve"/>
        }
        if (cur_script && script_load) {
            let btn_position = {
                zIndex: 10,
                top: '70vh',
                margin: "auto",
                width: "100%"
            };
            if (cur_script.choice_set.length > 1) {
                btn_position = {
                    zIndex: 10,
                    top: '50vh',
                    margin: "auto",
                    width: "100%"
                };
            }
            if (cur_script.is_next_scene) {
                next_scene_btn =
                    <div className="relative_btn" style={btn_position}>
                        <button className="text_btn fade_in"
                                onClick={(e) => this.nextScript(e, 0)}>다음
                        </button>
                    </div>
            }
            choice_set = <div className="btn_wrapper">
                {cur_script.choice_set ?
                    cur_script.choice_set.map((choice, index) => {
                        if (choice.position) {
                            btn_position = choice.position;
                        }
                        let button;
                        if (!choice.hidden) {
                            button =
                                <div key={index} className="relative_btn" style={btn_position}>
                                    <button
                                        className={"text_btn " + choice.dom_animation}
                                        key={index}
                                        onClick={(e) => this.nextScript(e, index)}
                                    >{choice.title}</button>
                                </div>
                        }
                        if (choice.img_url) {
                            let img_compo =
                                <img alt="img_btn"
                                     className={"img_btn " + choice.img_animation}
                                     src={choice.img_url}
                                     key={index}
                                     style={choice.img_style}/>

                            if (choice.title_is_top) {
                                button =
                                    <div className={"choice_btn " + choice.dom_animation}
                                         style={btn_position}
                                         key={index}
                                         onClick={(e) => {
                                             if (!choice.disabled) {
                                                 this.nextScript(e, index)
                                             }
                                         }}>
                                        <p className="btn_title" style={choice.title_style}>{choice.title}</p>
                                        {img_compo}
                                    </div>
                            } else {
                                button =
                                    <div className={"choice_btn " + choice.dom_animation}
                                         style={btn_position}
                                         key={index}
                                         onClick={(e) => {
                                             if (!choice.disabled) {
                                                 this.nextScript(e, index)
                                             }
                                         }}>
                                        {img_compo}
                                        <p className="btn_title" style={choice.title_style}>{choice.title}</p>
                                    </div>
                            }
                        }
                        return button
                    })
                    : null
                }
            </div>
        }
        if (cur_scene === 1 || cur_scene === 2) {
            back_ground = <div className="scene_one_background" style={trans_style}>
                <p className="easter_text">
                    SoCandy
                </p>
                <img alt="layer" className="background_1 layer_1"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Back-01-min.png"/>
                <img alt="layer" className="background_2 layer_2"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Back-00-min.png"/>
                <img alt="layer" className="background_3 layer_3"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Middle-01-min.png"/>
                <img alt="layer" className="background_4 layer_4"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Middle-00-min.png"/>
                <img alt="layer" className="background_5 layer_5"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Front-03-min.png"/>
                <img alt="layer" className="background_6 layer_6"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Front-02-min.png"/>
                <img alt="layer" className="background_7 layer_7"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Front-01.png"/>
                <img alt="layer" className="background_8 layer_8"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Front-00.png"/>
                <img alt="layer" className="background_9 layer_9"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-Leaf-01.png"/>
                <div className="wrapper">
                    {choice_set}
                </div>
            </div>
        } else if (cur_scene === 3 || cur_scene === 4 || cur_scene === 5) {
            back_ground = <div className="scene_two_background fade_in" style={trans_style}>
                {cur_script.background}
                <div className="wrapper">
                    {choice_set}
                </div>
            </div>
        } else if (cur_scene === 6) {
            back_ground = <div className="scene_three_background" style={trans_style}>
                {cur_script.background}
                <img className="background_1 fade_in_2s" alt="layer"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-01-bg-min.png"/>
                <img className="background_2 scene_3_left_center" alt="layer"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-Front-Left-min.png"/>
                <img className="background_4 scene_3_right_center" alt="layer"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-Front-Right-min.png"/>
                <div className="wrapper">
                    {choice_set}
                </div>
            </div>
        } else if (cur_scene === 7) {
            back_ground = <div className="scene_three_background" style={trans_style}>
                {cur_script.background}
                <div className="wrapper">
                    {choice_set}
                </div>
            </div>
        } else if (cur_scene === 8) {
            back_ground = <div className="scene_five_background" style={trans_style}>
                <img className="background_2 fade_in_2s" alt="layer"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_5/003-00-BG-min.png"/>
                <img className="scene_5_cloud" alt="layer"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_5/003-00-Cloud-min.png"/>
                <div className="scene_5_circle_1 scene_5_circle_1_1"/>
                <div className="scene_5_circle_2 scene_5_circle_2_1"/>
                <div className="scene_5_circle_3 scene_5_circle_3_1"/>
                <div className="wrapper">
                    {choice_set}
                </div>
            </div>
        } else if (cur_scene === 9) {
            back_ground = <div className="scene_five_background" style={trans_style}>
                <img className="background_1" alt="layer"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_5/003-00-BG-min.png"/>
                <div className="background_2 scene_six_background fade_in_2s"/>
                <img className="background_4 fade_in_2s" alt="layer"
                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_6/003-01-BG-min.png"/>
                <div className="delay_fade_in_2s"
                     style={{width: "100%", top: "0", zIndex: 3, position: "absolute"}}>
                    <div className="delay_fade_5s" style={{width: "100%", height: "80vh", margin: 'auto'}}>
                        <Particles width="100%" height="80vh" params={{
                            "particles": {
                                "shadow": {
                                    enable: true,
                                    color: "#eed038",
                                    blur: 2
                                },
                                "color": {
                                    value: "#ffffff"
                                },
                                "number": {
                                    "value": 70,
                                },
                                "line_linked": {
                                    "enable": false
                                },
                                "size": {
                                    "value": 3,
                                    "random": true,
                                    "anim": {
                                        "speed": 40,
                                        "size_min": 0.3
                                    }
                                },
                                "collisions": {
                                    "enable": false,
                                },
                                "move": {
                                    "direction": "none",
                                    "random": true,
                                    "speed": 0,
                                    "out_mode": "bounce"
                                }
                            }
                        }}/></div>
                </div>
                <div className="wrapper">
                    {choice_set}
                </div>
            </div>
        } else if (cur_scene === 10) {
            back_ground =
                <>
                    <p className="easter_text">
                        Kwang.Jong
                    </p>
                    <div className="scene_seven_background" style={trans_style}>
                        <img className="height_trans fade_in_2s" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-00-BG-min.png"/>
                        <p className="ampm blink">PM</p>
                        <p className="hour">{hour}</p>
                        <p className="minute">{minutes}</p>
                        <div className="wrapper">
                            {choice_set}
                        </div>
                    </div>
                    {cur_script.background}
                </>
        } else if (cur_scene === 11) {
            back_ground =
                <>
                    <div className="scene_eight_background" style={trans_style}>
                        <div className="all_dissolve_background fade_in_2s"/>
                        <img className="height_trans fade_out" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-00-BG-min.png"/>
                        <div className="wrapper">
                            {choice_set}
                        </div>
                    </div>
                </>
        }
        let sound_icon = <img alt="sound_icon" onClick={() => this.soundToggle()} className="sound_icon"
                              src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/sound-off.svg"/>;
        if (is_sound) {
            sound_icon = <img alt="sound_icon" onClick={() => this.soundToggle()} className="sound_icon"
                              src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/sound-on.svg"/>
        }
        return (
            <div className="script">
                {load_page}
                {back_ground}
                {sound_icon}
                <div className="absolute_wrapper">
                    <div className="wrapper">
                        {cur_script &&
                        <Typist cursor={{show: false, element: ''}} avgTypingDelay={70} onTypingDone={() => {
                            this.setLoad();
                        }}>
                            <span className="title">{cur_script.title}</span>
                            <span className="msg"
                                  style={{whiteSpace: 'pre-wrap'}}>{cur_script.msg}</span>
                        </Typist>
                        }
                    </div>
                </div>
                <div className="absolute_wrapper">
                    <div className="wrapper">
                        {cur_script && next_scene_load &&
                        <>
                            {next_scene_btn}
                        </>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Script;
